__turbopack_context__.v({
  "body": "fm9VlW_body",
  "callback": "fm9VlW_callback",
  "cardSpacer": "fm9VlW_cardSpacer",
  "heading": "fm9VlW_heading",
  "intro": "fm9VlW_intro",
  "introBody": "fm9VlW_introBody",
  "introCopy": "fm9VlW_introCopy",
  "label": "fm9VlW_label",
  "marker": "fm9VlW_marker",
  "panel": "fm9VlW_panel",
  "row": "fm9VlW_row",
  "rows": "fm9VlW_rows",
  "rule": "fm9VlW_rule",
  "side": "fm9VlW_side",
  "title": "fm9VlW_title",
});
